<template>
    <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12 package-wrapper">
        <div class="card-shadow bg-deveo-light" :class="'card-' + type">
            <div class="most-popular" v-if="header === 'vue-toastr'">
                <i class="fa fa-star fa-fw"></i> Most popular
            </div>
            <div class="card-logo">
                <img class="grey" v-if="type === 'vue'" src="/static/images/techicons/vue_grey.svg" />
                <img class="white" v-if="type === 'vue'" src="/static/images/techicons/vue_white.svg" />
                <img class="grey" v-if="type === 'laravel'" src="/static/images/techicons/laravel_grey.svg" />
                <img class="white" v-if="type === 'laravel'" src="/static/images/techicons/laravel_white.svg" />
            </div>
            <div class="headline">{{ header }}</div>
            <slot name="description"></slot>
            <div class="card-downloads">
                <div class="row">
                    <div class="col-lg-6 col-xs-6" v-if="downloads !== '' && downloads !== 0">
                        <i class="fa fa-fw fa-download"></i> {{ downloads }}
                    </div>
                    <div class="col-lg-6 col-xs-6" v-if="stars !== '' && stars !== 0">
                        <i class="fa fa-fw fa-star"></i> {{ stars }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            header: {
                required: true
            },
            description: {
            },
            downloads: {
                required: true
            },
            type: {
            },
            stars: {
            }
        }
    }
</script>
<style type="scss" scoped>
    a{
        color: initial !important;
        text-decoration: none !important;
    }
    .package-wrapper{
        margin: 0 0 30px 0;
    }
    .headline{
        word-wrap: break-word;
        text-transform: uppercase;
        font-weight: 500;
    }
    p{
        word-wrap: break-word;
        margin: 0;
        font-weight: 300;
        font-size: 0.8rem;
    }
    .card-logo{
        position: absolute;
        top: 15px;
        right: 30px;
    }
    .card-logo img.grey{
        display: block;
    }
    .card-logo img.white{
        display: none;
    }
    .card-shadow:hover img.grey{
        display: none;
    }
    .card-shadow:hover img.white{
        display: block;
    }
    .card-logo img{
        width: 30px;
        height: 30px;
        transition: 0.2s ease all;
    }
    .card-downloads{
        position: absolute;
        bottom: 15px;
        font-size: 0.8rem;
        width: calc(100% - 100px);
        opacity: 0.8;
    }
    .card-shadow:hover .card-downloads{
        opacity: 1;
    }
    .card-downloads *{
        padding: 0;
        margin: 0;
    }
    .card-shadow{
        border-top: 3px solid;
        padding: 50px 30px 70px 30px;
        transition: 0.2s ease-in-out all;
        height: 100%;
    }
    .card-shadow:hover{
        cursor: default;
        background: transparent;
    }
    .card-vue{ border-color: #4fc08d; }
    .card-vue:hover{ background: #4fc08d; color: #fff; }
    .card-laravel{ border-color: #f4645f; }
    .card-laravel:hover{ background: #f4645f; color: #fff; }
    .most-popular{
        background: #4fc08d;
        color: #fff;
        position: absolute;
        top: 22px;
        border-radius: 2px;
        padding: 2px 6px;
        font-size: 10px;
        transition: 0.2s ease-in-out all;
    }
    .card-shadow:hover .most-popular{
        background: #fff;
        color: #4fc08d;
    }
    .col-xs-6{
        width: 50%;
    }
</style>



// WEBPACK FOOTER //
// package.vue?2a2b3c1f